module.exports = __webpack_public_path__ + "img/H2.d3f9d23e.png";